import styled from "styled-components";
import { Section } from "./../../styled/index";

export const PortfolioStyled = styled(Section)`
  padding-bottom: 250px;
  padding-top: 20px;
  display: block;
`;

export const PortfolioTitle = styled.h1`
  text-align: center;
  line-height: 44px;
`;

export const PortfolioList = styled.ol`
  list-style: none;
  text-align: center;
  margin: 0;
  padding: 0;
`;
